import React, { FunctionComponent, useContext } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { URLStateContext } from '../URLState/URLState';
import CrashListPage from './CrashListPage/CrashListPage';
import CrashPage from './CrashPage/CrashPage';

const CrashesIndex: FunctionComponent = () => {
  const { to } = useContext(URLStateContext);

  return (
    <Switch>
      <Route component={CrashPage} path="/:appId/crashes/:crashId/event/:eventId?/:tab?" />
      <Redirect from="/:appId/crashes/:crashId" to={to(`/:appId/crashes/:crashId/event`)} />
      <Route component={CrashListPage} path="/:appId/crashes" />
    </Switch>
  );
};

export default CrashesIndex;
